import React, { useEffect, useState } from 'react'
import { CircularProgressbar,buildStyles  } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import { useLocation, useNavigate } from 'react-router-dom';
import Translate from "../../../Components/Multilanguage/Translate";
const waitingTime = 10;
let timerSeconds = waitingTime;
const Autoplay = ({ episodes, setIsAutoplayView, isPlaylist = false, onVideoChange, currentVideoId }) => {
    const [timer, setTimer] = useState(waitingTime)
    const navigate = useNavigate()
    const location = useLocation()

    useEffect(() => {
        if (isPlaylist && episodes) {
            playNextEpisodeHandler();
            return;
        }
        const interval = setInterval(() => {
                timerSeconds--
                if(timerSeconds>=0){
                    setTimer((prev)=>prev-1)
                }else{
                    clearInterval(interval)
                }
           
        }, 1000);

        return ()=>{
            clearInterval(interval)
            resetValues()
        }
    },[])

    useEffect(()=>{
        if(timer===0){
            playNextEpisodeHandler()
        }
    },[timer])

    const playNextEpisodeHandler = () =>{
        setIsAutoplayView(false)
        setTimer(waitingTime)
        timerSeconds = waitingTime
        
        const showId = 
            location?.state?.showId || 
            location?.state?.showDetails?.show_id || 
            localStorage.getItem('playlist_show_id');
            
        
        if (isPlaylist && episodes) {
            const currentIndex = episodes.findIndex(
                (episode) => episode.video_id === currentVideoId
            );

            const nextIndex = currentIndex + 1;
            if (nextIndex < episodes.length) {
                const nextEpisode = {
                    ...episodes[nextIndex],
                    video_type: 'playlist'
                };
                
                if (showId) {
                    localStorage.setItem('playlist_show_id', showId);
                    localStorage.setItem('playlist_vanity_url', nextEpisode.vanity_url);
                }
                
                onVideoChange(nextEpisode, showId);
            }
        } else {
            navigate(`/videos/${episodes[0]?.vanity_url}`, { state: { videoDetails: episodes[0] } })
        }
    }

    const resetValues = () => {
        setTimer(waitingTime)
        timerSeconds = waitingTime
    }

  return (
    <div className='autoplayComponent'>
        <div className="content">
            <div className="progressBar">
            <CircularProgressbar 
                value={Math.round((10-timer)*10)} 
                text={`${timer}s`}
                styles={buildStyles({
                    pathColor: `var(--button-color)`,
                    textColor:  `var(--button-color)`,
                })} 
            />
            </div>
            <span className="timer"><Translate textKey={'next_video'} /> {timer}s</span>
        </div>
    </div>
  )
}

export default Autoplay
